<template>
  <div>
    <h2 class="page-sub-title">
      {{ headerTitle }}
    </h2>
    <p v-dompurify-html="headerContent" />
  </div>
</template>

<script>
export default {
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
  },
};
</script>
